import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { BlameLogRefType, BlameLogType } from '@debbie/common/dist/blamelog/index.js';
import { c } from '@debbie/cortex/dist/index.js';
import { blameLogs } from '@debbie/cortex/dist/api/index.js';
import * as cosmoAPI from '@debbie/cortex/dist/api/cosmo.js';
import Button from '../Button.js';
import Input from '../Input.js';
import ExclusiveContent, { ExclusiveContentBadge } from '../ExclusiveContent.js';
import THEME from '../../theme.js';
import PlaceholderLoader from '../PlaceholderLoader.js';
import Alert from '../Alert.js';
import CopyToClipboard from '../CopyToClipboard.js';
const AKSSettings = (props) => {
    const lang = useSelector((s) => s.lang);
    const [aksKeyState, setAksKeyState] = useState(props.tenant.aksSettings.key);
    const [hideAKSStats, setHideAKSStats] = useState(true);
    const [aksCodeState, setAksCodeState] = useState(props.tenant.aksSettings.code);
    const [aksUsernameState, setAksUsernameState] = useState(props.tenant.aksSettings.username);
    const [aksPasswordState, setAksPasswordState] = useState(props.tenant.aksSettings.password);
    const save = () => {
        c.tenants.update(props.tenant.id, {
            aksSettings: {
                key: aksKeyState,
                code: aksCodeState,
                username: aksUsernameState,
                password: aksPasswordState,
            },
        });
        const changedAksSettings = {
            keyChanged: false,
            codeChanged: false,
            usernameChanged: false,
            passwordChanged: false,
        };
        props.tenant.aksSettings.key !== aksKeyState &&
            (changedAksSettings.keyChanged = true);
        props.tenant.aksSettings.code !== aksCodeState &&
            (changedAksSettings.codeChanged = true);
        props.tenant.aksSettings.username !== aksUsernameState &&
            (changedAksSettings.usernameChanged = true);
        props.tenant.aksSettings.password !== aksPasswordState &&
            (changedAksSettings.passwordChanged = true);
        const blameLog = {
            details: changedAksSettings,
            refId: props.tenant.id,
            refType: BlameLogRefType.TenantSettings,
            type: BlameLogType.AKSConfiguration,
        };
        blameLogs.createBlameLog(blameLog, props.tenant.id);
    };
    return (React.createElement("div", null,
        props.tenant.aksSettings.username &&
            props.tenant.aksSettings.password && (React.createElement(ExclusiveContent, null, hideAKSStats ? (React.createElement(React.Fragment, null,
            React.createElement("p", { onClick: () => {
                    setHideAKSStats(false);
                }, style: {
                    cursor: 'pointer',
                    color: THEME.COLOR_ACCENT,
                    fontWeight: '900',
                    fontSize: '0.8em',
                } },
                "Vis AKS statistik ",
                React.createElement(ExclusiveContentBadge, null)))) : (React.createElement(AKSStats, null)))),
        React.createElement(Input, { placeholder: lang.tenants.AKSKey, value: aksKeyState, onChange: (e) => setAksKeyState(e.target.value) }),
        React.createElement(Input, { placeholder: lang.tenants.AKSCode, value: aksCodeState, onChange: (e) => setAksCodeState(e.target.value) }),
        React.createElement(Input, { placeholder: lang.tenants.AKSUsername, value: aksUsernameState, onChange: (e) => setAksUsernameState(e.target.value) }),
        React.createElement(Input, { placeholder: lang.tenants.AKSPassword, value: aksPasswordState, onChange: (e) => setAksPasswordState(e.target.value), sensitive: true }),
        React.createElement(Button, { onClick: save }, lang.misc.save)));
};
export default AKSSettings;
const AKSStats = () => {
    const [loading, setLoading] = useState(false);
    const [aksStats, setAKSStats] = useState(null);
    const loadAKSStats = async () => {
        const stats = await cosmoAPI.experianAKSStats();
        setAKSStats(stats);
    };
    useEffect(() => {
        loadAKSStats();
    }, []);
    return (React.createElement("div", null, aksStats ? (React.createElement("div", null,
        React.createElement("p", null,
            React.createElement("b", null, aksStats.enrolledInCosmo),
            " tilmeldte debitorer i Debbie.",
            ' ',
            React.createElement("b", null, aksStats.enrolledInExperian),
            " tilmeldt if\u00F8lge Experian AKS."),
        !!aksStats.discrepancy?.shouldBeEnrolledInAKS.length && (React.createElement(Alert, { message: React.createElement(React.Fragment, null,
                React.createElement(CopyToClipboard, { text: JSON.stringify(aksStats.discrepancy?.shouldBeEnrolledInAKS) },
                    aksStats.discrepancy?.shouldBeEnrolledInAKS.length,
                    ' ',
                    "debitorer er ikke tilmeldt, men kan tilmeldes AKS")) })),
        React.createElement(Button, { size: "mini", disabled: !(aksStats.discrepancy?.inAKSButNotInCosmo.length ||
                aksStats.discrepancy?.inCosmoButNotAtAKS.length), loading: loading, onClick: async () => {
                try {
                    setLoading(true);
                    await cosmoAPI.experianAKSStats({
                        leaveExcessAKSSubscriptions: true,
                        removeExcessAKSEventsInCosmo: true,
                    });
                }
                catch (error) {
                    console.error('Error removing AKS subscriptions:', error);
                    alert('Error');
                }
                setLoading(false);
            } },
            "Afmeld ",
            aksStats.discrepancy?.inAKSButNotInCosmo.length || 0,
            ' ',
            "uidentificerede tilmeldinger fra AKS og fjern",
            ' ',
            aksStats.discrepancy?.inCosmoButNotAtAKS.length || 0,
            " tilmeldinger i Cosmo som ikke er i AKS."),
        React.createElement("br", null),
        React.createElement("br", null))) : (React.createElement(PlaceholderLoader, null))));
};
//# sourceMappingURL=AKSSettings.js.map